module.exports = __webpack_public_path__ + "a4c3c8fb760068ea8f2fb720c6dd0bac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bagpipes-s.png
// module id = 1843
// module chunks = 0